import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Nav,
  NavItem,
  NavLink,
  Table,
  Row,
  Col,
  CardTitle,
  CardText,
} from "reactstrap";
import classnames from "classnames";
import usersModel from "models/users.model";
import TransactionDetails from "./TransactionDetails";
import BookingDetails from "./BookingDetails";
import BankDetails from "./BankDetails";
import VerificationDetails from "./VerificationDetails";
import BasicDetails from "./BasicDetails";
import UserActivity from "./UserActivity";
import UserMessages from "./UserMessages";


const ViewUser = () => {
  const { id } = useParams();
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("1");
  const navigate = useNavigate();
  const [us, setUs] = useState(null);

  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");

  useEffect(() => {
    const getUserDetails = async () => {
      try {
        console.log(id);
        const res = await usersModel.getSpecificUser(id);
        console.log(res);
        setUser(res?.data);
        setIsLoading(false);
      } catch (error) {
        console.log(error);
      }
    };

    getUserDetails();

  }, [id]);

  console.log("user",user);

  const filteredBookings = us?.filter((item) => {
    const addedOnDate = new Date(item?.addedOn);
    const from = dateFrom ? new Date(dateFrom) : null;
    const to = dateTo ? new Date(dateTo) : null;

    return (!from || addedOnDate >= from) && (!to || addedOnDate <= to);
  });

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <Container className="pt-7 ">
      <Card className="shadow ">
        <CardHeader>
          <Nav tabs>
            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({ active: activeTab === "1" })}
                onClick={() => toggle("1")}
              >
                Basic Details
              </NavLink>
            </NavItem>
            {user.type === "buddy" && (
              <>
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({ active: activeTab === "2" })}
                    onClick={() => toggle("2")}
                  >
                    Verification Details
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({ active: activeTab === "3" })}
                    onClick={() => toggle("3")}
                  >
                    Bank Details
                  </NavLink>
                </NavItem>
              </>
            )}
            {/* <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({ active: activeTab === "4" })}
                onClick={() => toggle("4")}
              >
                To-do List
              </NavLink>
            </NavItem> */}
            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({ active: activeTab === "4" })}
                onClick={() => toggle("4")}
              >
                Bookings
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({ active: activeTab === "5" })}
                onClick={() => toggle("5")}
              >
                Transactions
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({ active: activeTab === "6" })}
                onClick={() => toggle("6")}
              >
                User Activity
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({ active: activeTab === "7" })}
                onClick={() => toggle("7")}
              >
                Messages
              </NavLink>
            </NavItem>
          </Nav>
        </CardHeader>
        <CardBody>
          {user && activeTab === "1" && (
            <BasicDetails user={user} navigate={navigate} id={id} />
          )}

          {activeTab === "2" && <VerificationDetails user={user} />}

          {activeTab === "3" && <BankDetails user={user} />}

          {activeTab === "4" && (
            <BookingDetails
              filteredBookings={filteredBookings}
              user={user}
              isLoading={isLoading}
            />
          )}

          {activeTab === "5" && (
            <TransactionDetails user={user} isLoading={isLoading} />
          )}

          {/* yet to decide */}
          {activeTab === "6tbd" && (
            <Container className="">
              {!isLoading && (
                <Row>
                  <div className="col">
                    <Card className="shadow">
                      <CardHeader className="border-0 d-flex justify-content-between align-items-center">
                        <h3 className="mb-0">User Enquiry</h3>
                      </CardHeader>
                      <Table
                        className="align-items-center table-flush"
                        responsive
                      >
                        <thead className="thead-light">
                          <tr>
                            <th scope="col">S.No</th>
                            <th scope="col">Enquiry</th>
                            <th scope="col">Data</th>
                            <th scope="col">Status</th>
                            <th scope="col">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {user.enquiry.map((enquiry, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{enquiry.enquiry}</td>
                              <td>{enquiry.data}</td>
                              <td>{enquiry.status}</td>
                              <td>
                                <Button
                                  color="info"
                                  size="sm"
                                  className="mr-2"
                                  // onClick={() => handleViewMore(index)}
                                >
                                  <i className="fa-solid fa-eye"></i>
                                </Button>
                                <Button
                                  color="warning"
                                  size="sm"
                                  className="mr-2"
                                  // onClick={() => handleEdit(index)}
                                >
                                  <i className="fa-regular fa-pen-to-square"></i>
                                </Button>
                                <Button
                                  color="danger"
                                  size="sm"
                                  // onClick={() => handleDelete(index)}
                                >
                                  <i className="fa-solid fa-trash"></i>
                                </Button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </Card>
                  </div>
                </Row>
              )}
            </Container>
          )}

          {activeTab === "6" && <UserActivity />}

          {activeTab === "7" && <UserMessages />}
        </CardBody>
      </Card>
    </Container>
  );
};

export default ViewUser;
